<script>
import _ from 'lodash'
import UserActionRequiredCard from '../userActionRequired/UserActionRequiredCard.vue'

export default {
  components: {
    UserActionRequiredCard
  },
  props: {
    order: {
      type: Object
    },
    documentData: {
      type: Object
    },
    documentId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    nonRepeatingValidationCodes() {
      const nonRepeatingValidationResults = [
        ...new Map(
          this.documentData.validationResults.map(item => [
            item.validationCode,
            item
          ])
        ).values()
      ]
      //make an array from validation codes of each object
      return nonRepeatingValidationResults
        .map(item => item.validationCode)
        .sort()
    },
    postageFailed() {
      return (
        _.includes(
          this.nonRepeatingValidationCodes,
          this.$enums.validationCode.FrankingOnEnvelopePossible
        ) ||
        _.includes(
          this.nonRepeatingValidationCodes,
          this.$enums.validationCode.ZipCodeValidationFailed
        )
      )
    },
    prodAreaFailed() {
      return _.includes(
        this.nonRepeatingValidationCodes,
        this.$enums.validationCode.ProductionNoteAreaNotFree
      )
    },
    fontFailed() {
      return (
        _.includes(
          this.nonRepeatingValidationCodes,
          this.$enums.validationCode.FontIsNotEmbedded
        ) && this.$permissions.hasFontValidationOverride
      )
    },
    duplicatesFailed() {
      return _.includes(
        this.nonRepeatingValidationCodes,
        this.$enums.validationCode.DuplicatesExists
      )
    },
    warnings() {
      const userActionRequired = this.$enums.UserActionRequired
      let warnings = []
      this.postageFailed && warnings.push(userActionRequired.postage)
      this.prodAreaFailed && warnings.push(userActionRequired.productionNote)
      this.fontFailed && warnings.push(userActionRequired.font)
      this.duplicatesFailed && warnings.push(userActionRequired.duplicates)
      return warnings
    },
    isUserActionRequired() {
      return Object.values(this.warnings).some(action => action)
    }
  },
  methods: {
    confirmWarnings() {
      this.loading = true
      this.$uploadService
        .confirmWarnings({
          OrderId: this.order.orderId,
          DocumentIds: [this.documentId],
          PostageOnCover: this.postageFailed,
          ConfirmProductionArea: this.prodAreaFailed,
          ConfirmFontWarnings: this.fontFailed,
          DeleteDuplicates: this.duplicatesFailed
        })
        .then(() => {
          this.$emit('confirmed')
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<template>
  <UserActionRequiredCard
    v-if="isUserActionRequired"
    :warnings="warnings"
    :loading="loading"
    identifier="upload-dialog-document-preview-confirmation-button"
    class="ml-6 mt-6 mb-6"
    long-tooltip
    :order-id="order.orderId"
    @confirmWarnings="confirmWarnings"
  />
</template>
